/**
 * Deterministic learner ordering for instructor roster UI.
 * Must match backend learner_roster.display_name_sort_key / sort_learners_by_display_name.
 * Identity is always learner.id — never display_name.
 */
export function displayNameSortKey(learner) {
  const name = (learner?.display_name || "").trim();
  const email = (learner?.email || "").trim();
  return [name.toLocaleLowerCase(), email.toLocaleLowerCase(), learner?.id || ""];
}

export function compareLearnersForRoster(a, b) {
  const ka = displayNameSortKey(a);
  const kb = displayNameSortKey(b);
  for (let i = 0; i < 3; i += 1) {
    if (ka[i] < kb[i]) return -1;
    if (ka[i] > kb[i]) return 1;
  }
  return 0;
}

export function sortLearnersByDisplayName(learners) {
  return [...learners].sort(compareLearnersForRoster);
}
